// We're getting a bunch of html from the server and shoving it into react here.

import * as React from 'react';
import {withRouter} from 'react-router-dom';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import {ClientRouteLegacyLinks} from '../../client-route-legacy-links';

type OwnProps = {
    peepMarkup: HTMLElement | null | undefined;
    isLoading: boolean;
    onMarkupRendered: () => void;
};

type Props = OwnProps & ContextRouter;

export class PeepContentsComponent extends React.Component<Props> {
    render() {
        const {peepMarkup} = this.props;
        if (!peepMarkup) return null;

        return (
            <ClientRouteLegacyLinks history={this.props.history}>
                {({interceptClicks}) =>
                    // @ts-expect-error
                    this.props.isLoading ? null : (
                        <div
                            ref={(ref) => {
                                if (ref && this.props.onMarkupRendered) {
                                    this.props.onMarkupRendered();
                                }
                            }}
                            onClick={interceptClicks}
                            dangerouslySetInnerHTML={{
                                __html: peepMarkup.innerHTML,
                            }}
                        />
                    )
                }
            </ClientRouteLegacyLinks>
        );
    }
}

// @ts-expect-error
export const PeepContents = withRouter<OwnProps>(PeepContentsComponent);
